import FastClick from '@idg/fastclick';
let inited = false;
if (!inited && 'addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', () => {
        FastClick.attach(document.body);
    }, false);
    inited = true;
}
